import { gql } from "@apollo/client";

export const insuranceData = gql`
  fragment insuranceData on InsuranceData {
    documentId
    offerTypeId
    insuranceTypeId
    financingType
    activityTypeId
    currencyId
    currencyCode
    monthNo
    period
    startDate
    insuranceAmount
    insuredId
    clientId
    financingDocumentId
    financingDocumentSiteId
    financingDocumentNumber
    sourceDocumentId
    sourceDocumentNumber
    userId
    userName
    assetId
    quotationId
    currentPolicyMaintained
    externalBeneficiary
    insuredAmount
    selectedPeriods
    selectedInsurers {
      insurerId
      requestedCommissionPercent
    }
  }
`;

export const attachment = gql`
  fragment attachment on Attachment {
    documentAttachmentId
    documentId
    isVerified
    entityTitle
    entityType
    entityPK1
    entityPK2
    contentType
    requiredDocTypeId
    requiredDocumentName
    userId
    userName
    uploadedDate
    validityDate
    attachmentComment
    fileUniqueId
    stateId
    stateName
    isExternal
    mandatory
    properties {
      propertyId
      propertyName
      propertyCode
      value
      mandatory
      readOnly
      propertyTypeCode
      allowDefaultRead
      allowDefaultWrite
    }
  }
`;

export const print = gql`
  fragment print on Print {
    documentPrintId
    documentId
    templateId
    templateName
    entityTitle
    entityType
    userId
    userName
    uploadedDate
    needsSigning
    templateForSign
    signStatusName
    signatureDate
    signatureTypeId
    fileUniqueId
    signatureTypes {
      id
      code
      name
    }
  }
`;

export const documentTransition = gql`
  fragment documentTransition on DocumentTransition {
    transitionId
    initialStateId
    initialStateCode
    initialStateName
    finalStateId
    finalStateCode
    finalStateName
  }
`;

export const stateTransition = gql`
  fragment stateTransition on DocumentStateTransition {
    id
    stateName
    userName
    transitionMoment
  }
`;

export const dmsFileInfo = gql`
  fragment dmsFileInfo on DMSFileInfo {
    uniqueId
    originalFileName
    userName
    uploadDate
    fileVersion
  }
`;

export const cascoQuotationExtended = gql`
  fragment cascoQuotationExtended on CascoQuotationItem {
    risks {
      quotationRiskId
      riskTypeId
      riskName
      implicit
      selected
      mandatory
      readOnly
    }
    coefficients {
      additionalDataTypeId
      additionalDataName
      allowMultipleDetails
      details {
        detailId
        detailName
        selected
      }
    }
    totalDamageDeductibleCosts {
      id
      value
    }
    partialDamageDeductibleCosts {
      id
      value
      currencyCode
    }
  }
`;

export const cascoQuotationBase = gql`
  fragment cascoQuotationBase on CascoQuotationItem {
    quotationId
    insurerId
    insurerName
    period
    monthNo
    periodicity
    suplementPeriod
    conventionId
    conventionName
    totalDamageDeductiblePercent
    partialDamageDeductibleAmount
    partialDamageDeductibleCurrency
    insuranceAmount
    totalInsuranceAmount
    discountPercent
    discountAmount
    freeTxt
    errorMessage
    sourceQuotationId
    sourceQuotation
    manualQuotation
    insuredAmount
    isActive
    quotationDate
    lockedYN
  }
`;

export const cascoQuotationsValues = gql`
  fragment cascoQuotationsValues on InsuranceQuotationsList {
    values {
      ...cascoQuotationBase
      ...cascoQuotationExtended
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
`;

export const comment = gql`
  fragment comment on Comment {
    documentCommentId
    freeTxt
    internalTime
    userId
    userName
    stateId
    stateName
  }
`;

export const documentHeader = gql`
  fragment documentHeader on DocumentHeader {
    documentId
    documentNumber
    documentStateId
    documentStateName
    documentStateCode
    documentDate
    clientName
    insuranceTypeId
    documentTypeId
    insuranceTypeName
    offerTypeCode
    generationInProgress
  }
`;
